import React from "react";
import { COLORS } from "@/constants";

// Full-screen fallback for a broken auth bootstrap. Default use is the
// AuthContext `stalled` watchdog, where everything above the loading gate is
// stuck and the only reliable recovery is a full reload — retrying in place
// would re-await the same dead promise. Consumers with a retryable failure
// (profile fetch error) pass their own `message` and `onRetry` instead.
export const AuthStalledScreen = ({
  longPressHandlers,
  message = "การเชื่อมต่อใช้เวลานานผิดปกติ กรุณาลองใหม่อีกครั้ง",
  onRetry,
}: {
  longPressHandlers?: Record<string, unknown>;
  message?: string;
  onRetry?: () => void;
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 16,
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100dvh",
      padding: 24,
      textAlign: "center",
      color: COLORS.text.pagePrimary,
      backgroundColor: COLORS.background.bodyDefault,
    }}
    {...longPressHandlers}
  >
    <div>{message}</div>
    <button
      type="button"
      onClick={onRetry ?? (() => globalThis.location.reload())}
      style={{
        padding: "10px 24px",
        borderRadius: 999,
        border: "none",
        fontWeight: 700,
        fontSize: 15,
        cursor: "pointer",
        color: COLORS.button.primaryColor,
        background: COLORS.button.primaryBackground,
      }}
    >
      ลองใหม่
    </button>
  </div>
);
